import * as React from 'react';
import styled from "styled-components"
import {  Navigate ,useNavigate} from "react-router-dom";
import log from '../images/LuxinHotel.png';
import BoxDesign from '../reports/BoxDesign';
import { useReactToPrint } from "react-to-print";
import { useState } from 'react';
import { apiMain } from '../../App';
import { useEffect } from 'react';
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
import Paper from '@mui/material/Paper';
import { MainData } from '../data/MainData';
import { usePDF } from "@react-pdf/renderer";
import img from '../images/Room1.png';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import Button from '@mui/material/Button';
import { useRef } from 'react';
import HotelVoucher_Print from './HotelVoucher_Print';
import MyPdf from './Mypdf2';

const Styles = styled.div`
  min-height: calc(100svh - 60px);
  display: flex;
  flex-direction: column;
  isolation: isolate;
  position: relative;
  .top-box {
    margin: 1rem 1rem 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
    }
    .rowleft {
      /* display:flex; */
      align-items: left;
      justify-content: space-between;
      position: absolute;
      /* padding-left:450px; */
      margin-left:230px;
    }

    .filter-title {
      padding: 1.5rem 2rem;
      font-size: 1.25rem;
      font-weight: 700;
    }
    .expand {
      flex-grow: 1;
    }
    .actions {
      padding: 0 2rem;
      display: flex;
      justify-content: end;
      gap: 0.5rem;
    }
  }
  .filters {
    margin: 0 1rem 1rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
    align-items: center;
    position: relative;
    padding: 1.5rem 2rem 0.5rem;
  }
  .table {
    margin: 0 1rem;
    display: grid;
    grid-template-columns:38px repeat(10, 1fr);
    align-items: center;
    position: relative;
    padding: 1rem;
    overflow-x: scroll;
    overflow-y: hidden;
    .top-table {
      grid-column: 11 span;
      display: flex;
      align-items: center;
      margin: 0 0 1rem;
      .expand {
        flex-grow: 1;
      }
      .actions {
        display: flex;
        gap: 0.3rem;
      }
    }
    .printing {
      display: none;
      @media print {
        @page {
          size: 445.5mm 315mm;
          margin: 1.5rem;
          padding: 2px;
        }
      }
    }
    .scroll-body {
      font-size: 0.8rem;
      grid-column: 11 span;
      display: grid;
      grid-template-columns:1fr;
      align-items: center;
      position: relative;
      min-width: 1000px;
      @media print {
        @page {
          size: 445.5mm 315mm;
          margin: 1.5rem;
          padding: 2px;
        }
      }
    }
    .no-match {
      /* grid-column: 13 span; */
    }
    /* .cel {
      border: 1px solid #555555;
      padding: 0.7rem 0.1rem;
      font-size: 0.8rem;
      width: calc(100% - 0.2rem);
      height: calc(100% - 1.4rem);
      align-items: center;
      display: flex;
      justify-content: center;
      &.header {
        font-weight: 700;
        border-bottom: 1px solid var(--n-grey-11);
      }
      &.action {
        display: flex;
        gap: 0.3rem;
        padding: 0 0.25rem;
        width: calc(100% - 0.5rem);
        height: calc(100%);
        grid-column: 2 span;
      }
    } */
  }
  @media screen and (max-width: 850px) {
    padding-bottom: 80px;
    .top-box {
      align-items: flex-start;
      flex-direction: column;
      .filter-title {
        padding: 1.5rem 1rem;
      }
      .actions {
        padding: 0.75rem 1rem;
      }
    }
    .filters {
      padding: 1.5rem 1rem 0.5rem;
      grid-template-columns: repeat(1, 1fr);
      gap: 0.5rem;
    }
  }
`


function createData(name, calories) {
  return { name, calories };
}

export default function HotelVoucher(props){
  let navigate = useNavigate(); 
  const componentRef = useRef();

  const print = useReactToPrint({

    content: () => componentRef.current,
    documentTitle: "report passneger from " ,
  })


  useEffect(() => {
    getData();
   }, [])

  let today=new Date();
  const [Pass_FName, setPass_FName] = useState("");
  const [Pass_LName, setPass_LName] = useState("");
  const [Original, setOriginal] = useState("");
  const [Genius, setGenius] = useState("");
  const [Advance, setAdvance] = useState("");
  const [Adults_No, setAdults_No] = useState("");
  const [Checkindate, setCheckindate] = useState("");
  const [Checkoutdate, setCheckoutdate] = useState("");
  const [Data,setData]=useState([]);

  const [Pass_Id, setPass_Id] = useState(0);
  const getData = async ( ) => {
    let uparams = new URLSearchParams();
    uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
      let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectreservid?${uparams}`, false);

    let parsed = JSON.parse(res);
    console.log(parsed)
    if((parsed.status && parsed.status !== "error") || parsed.data.length === "success"){
        let newData = parsed.data;
        setData(newData)
        setCheckindate(newData[0].Reserv_Checkindate) 
        setCheckoutdate(newData[0].Reserv_Checkoutdate) 
        setAdults_No(newData[0].Adults_No)
      setPass_FName(newData[0].Pass_FName)
      setPass_LName(newData[0].Pass_LName)
      setOriginal(newData[0].Reserv_Price)
      setGenius(newData[0].Reserv_prepayment)
      setAdvance(newData[0].Reserv_Account)
}
  }
  // const [{ loading, url, error }] = usePDF({
  //   // قالب پی دی اف خود را به عنوان داکیومنت این هوک معرفی می کنیم
  //   document: <MyPdf />,
  // });
     return (
     <>
         {/* با زدن دکمه زیر، فرایند دانلود فایل پی دی اف آغاز خواهد شد */}
      {/* <a href={url} >Pdf Download </a> */}
     <div style={{ border: 'solid' }}>
            
        <Styles>
        <div className='row'>
          <div className='header-row' >

            <img src={log} alt="farazandishan"  />
          </div>
          <div style={{marginLeft:'20px',fontSize:'22px' ,fontWeight:'bold', alignContent: 'left' ,float:'left' ,marginTop:'-80px'}} >
         <div     >
            Hotel Voucher
          </div>
        </div> 

        </div>
          
        <BoxDesign className={"top-box"} style={{border:'solid'}}>
         

          {/* <div className='rowleft' style={{ border: 'solid', marginLeft: '10px', marginRight: '10px' }} > */}
            <div className='filter-title' style={{ display: 'flex' }}>

              <TableContainer component={Table}  >
                <Table size='small' >

                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px', width: '150px' }} >Hotel Name:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}> Luxin Hotel</TableCell>
                    </TableRow>
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px' }}>City: </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>Tbilisi</TableCell>
                    </TableRow>
                    <TableRow
                      key={3}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px' }}>website:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>luxinhotel.com</TableCell>
                    </TableRow>
                    <TableRow
                      key={4}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px' }}>Email:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>info@luxinhotel.com</TableCell>
                    </TableRow>
                    <TableRow
                      key={5}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '14px' }}>Tel:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>+995511225552</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>


              <TableContainer component={Table} style={{ marginLeft: '350px' }}  >
                <Table size='small'  >

                  <TableBody>

                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }} >Check In:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}> {Checkindate.slice(0, 10)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={2}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }}>Check Out: </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>{Checkoutdate.slice(0, 10)}</TableCell>
                    </TableRow>
                    <TableRow
                      key={3}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }}>Room:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>Standard</TableCell>
                    </TableRow>
                    <TableRow
                      key={4}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }}>Room Service:</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}>Bed & Breakfast</TableCell>
                    </TableRow>
                    <TableRow
                      key={5}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                      <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '18px' }}></TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '18px' }}></TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            <div className='filters' style={{ display: 'inherit', float: 'center', marginRight: '10px' }}>
            <img src={img} alt="/" style={{ width: '200px', height: '200px' }} />
          </div>
          {/* </div> */}
        </BoxDesign>
        <br></br>
        <BoxDesign className={"filters"} style={{ border:'solid' }}>
          <div className='row' style={{float:'center',display:'inherit'}}>
               passneger Detail
               <TableContainer component={Paper} style={{ width: '800px' }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead style={{ backgroundColor: '#F2F2F2' }}>
                  <TableRow >
                    <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>First Name</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }} >Last Name</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }} >Passport No</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }}>Telephone (mobile number) </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Data.map((row) => (
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0, fontSize: '12px', fontWeight: 'bold' } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.Pass_FName}
                      </TableCell>
                      <TableCell align="left">{row.Pass_LName}</TableCell>
                      <TableCell align="left">{row.Pass_No}</TableCell>
                      <TableCell align="left">{row.Pass_PhonNo}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        {/* <div className='row' style={{display:'inherit'}}>
            <TableContainer component={Paper} style={{ width: 'auto' ,float:'left'}}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead style={{ backgroundColor: '#F2F2F2' }}>
                  <TableRow >
                    <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>First Name</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }} >Last Name</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }} >Passport No</TableCell>
                    <TableCell align="left" style={{ fontSize: '14px', fontWeight: 'bold' }}>Telephone (mobile number) </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Data.map((row) => (
                    <TableRow
                      key={1}
                      sx={{ '&:last-child td, &:last-child th': { border: 0, fontSize: '12px', fontWeight: 'bold' } }}
                    >
                      <TableCell component="th" scope="row">
                        {row.Pass_FName}
                      </TableCell>
                      <TableCell align="left">{row.Pass_LName}</TableCell>
                      <TableCell align="left">{row.Pass_No}</TableCell>
                      <TableCell align="left">{row.Pass_PhonNo}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            </div> */}
          </BoxDesign>
 
              
               <BoxDesign className={"top-box"}>
        
              <div className='title' >
                Adress:12-4 konstantin Eristavi Dead end, Tbilisi
                 </div>
                 </BoxDesign>  
                 <BoxDesign className={"top-box"}>
                 <div className='title' >
             
                   Location: Avlabari , Tbilisi, Georgia
                
              </div>
               {/* <Button onClick={()=>url()} variant="contained">PDF</Button> */}
     <MyPdf />

              <Button onClick={()=>{print()}} variant="contained">Print</Button>
            
           
               </BoxDesign>  
               
            <div   style={{display:'none'}}> 
                   <div className='printing' ref={componentRef}>
                      <HotelVoucher_Print 
                      Checkindate={Checkindate}
                      Checkoutdate={Checkoutdate}
                      Adults_No={Adults_No}
                      datas={Data} />
             
                    </div>
           </div>
           
        </Styles>

           <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d23832.040994894236!2d44.78582962718244!3d41.69882507819522!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40440d6603b3eff5%3A0x9d5701ffffe92de!2sLuxin%20Hotel!5e0!3m2!1sen!2s!4v1735463343308!5m2!1sen!2s" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
           </div>
         </>
    )
}